var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconecBge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 83,
    viewBox: "0 0 124 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8218 13.6895L45.6814 19.6814H26.4077C25.842 19.6814 25.3116 19.9898 25.0287 20.4822C24.7459 20.9776 24.7459 21.5916 25.0287 22.087L40.186 48.5728L34.8733 76.4914C34.7731 77.0134 34.0925 77.1499 33.8008 76.7079L0.0975701 25.1779C-0.126371 24.8338 0.0533711 24.374 0.451162 24.2761L46.1028 13.0013C46.5183 12.9005 46.9013 13.2653 46.8218 13.6895Z",
    fill: "#C25450"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.227 17.7066L87.7857 76.1324C87.4056 76.7601 86.4539 76.5617 86.3537 75.8334L82.6263 48.7062L97.7687 22.2954C98.0515 21.801 98.0515 21.1882 97.7657 20.6938C97.4829 20.2023 96.9554 19.8944 96.3867 19.8944H78.6661L76.0525 0.884968C75.9729 0.304706 76.5357 -0.151213 77.0838 0.0471412L122.826 16.5668C123.289 16.7356 123.483 17.2862 123.227 17.7066Z",
    fill: "#C25450"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8357 21.7135L82.3912 46.9554L61.9238 82.7201C61.8151 82.9094 61.627 83.0012 61.4388 83.0012C61.2507 83.0012 61.0596 82.9094 60.9538 82.7201L40.5687 47.0944L26.042 21.7135C25.8274 21.3377 26.0978 20.8672 26.527 20.8672H96.3477C96.7798 20.8672 97.0503 21.3377 96.8357 21.7135Z",
    fill: "#C25450"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconecBge);
export default __webpack_public_path__ + "static/media/iconec_bge.c68a060b3c03af6abfdb02bcaea9a100.svg";
export { ForwardRef as ReactComponent };